var _path, _mask, _path2, _path3, _mask2, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z",
    fill: "#FF6E65"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_323_15060",
    maskUnits: "userSpaceOnUse",
    x: 9.99268,
    y: 4,
    width: 4,
    height: 12,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9.99268,
    y: 4,
    width: 4,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0065 6.02366C13.0158 5.46107 12.5623 5 11.9996 5C11.4364 5 10.9827 5.46201 10.9928 6.02517L11.1397 14.1495C11.1483 14.6217 11.5335 15 12.0058 15C12.4785 15 12.864 14.6209 12.8718 14.1482L13.0065 6.02366Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0065 6.02366C13.0158 5.46107 12.5623 5 11.9996 5C11.4364 5 10.9827 5.46201 10.9928 6.02517L11.1397 14.1495C11.1483 14.6217 11.5335 15 12.0058 15C12.4785 15 12.864 14.6209 12.8718 14.1482L13.0065 6.02366Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0065 6.02366L13.2065 6.02697V6.02697L13.0065 6.02366ZM10.9928 6.02517L11.1928 6.02156L10.9928 6.02517ZM11.1397 14.1495L10.9398 14.1531L11.1397 14.1495ZM12.8718 14.1482L12.6719 14.1449L12.8718 14.1482ZM11.9996 5.2C12.4506 5.2 12.814 5.5695 12.8065 6.02034L13.2065 6.02697C13.2176 5.35265 12.6741 4.8 11.9996 4.8V5.2ZM11.1928 6.02156C11.1847 5.57025 11.5483 5.2 11.9996 5.2V4.8C11.3245 4.8 10.7807 5.35377 10.7929 6.02879L11.1928 6.02156ZM11.3397 14.1459L11.1928 6.02156L10.7929 6.02879L10.9398 14.1531L11.3397 14.1459ZM12.0058 14.8C11.6425 14.8 11.3463 14.509 11.3397 14.1459L10.9398 14.1531C10.9503 14.7343 11.4245 15.2 12.0058 15.2V14.8ZM12.6719 14.1449C12.6658 14.5084 12.3694 14.8 12.0058 14.8V15.2C12.5877 15.2 13.0622 14.7334 13.0718 14.1515L12.6719 14.1449ZM12.8065 6.02034L12.6719 14.1449L13.0718 14.1515L13.2065 6.02697L12.8065 6.02034Z",
    fill: "white",
    mask: "url(#path-2-outside-1_323_15060)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-2_323_15060",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15.5625,
    width: 4,
    height: 4,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 10,
    y: 15.5625,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0065 16.5625C11.4517 16.569 10.9936 17.0141 11.0001 17.556C10.9936 18.1109 11.4517 18.5625 12.0065 18.5625C12.542 18.5625 13 18.1109 13 17.556C13 17.0141 12.542 16.569 12.0065 16.5625Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0065 16.5625C11.4517 16.569 10.9936 17.0141 11.0001 17.556C10.9936 18.1109 11.4517 18.5625 12.0065 18.5625C12.542 18.5625 13 18.1109 13 17.556C13 17.0141 12.542 16.569 12.0065 16.5625Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 17.556L11.2001 17.5584L11.2001 17.5537L11.0001 17.556ZM12.0065 16.5625L12.0089 16.3625L12.0042 16.3625L12.0065 16.5625ZM11.2001 17.5537C11.195 17.1299 11.5566 16.7677 12.0088 16.7625L12.0042 16.3625C11.3467 16.3702 10.7922 16.8983 10.8001 17.5584L11.2001 17.5537ZM12.0065 18.3625C11.56 18.3625 11.1949 17.9988 11.2001 17.5584L10.8001 17.5537C10.7923 18.2229 11.3433 18.7625 12.0065 18.7625V18.3625ZM12.8 17.556C12.8 18.0013 12.4307 18.3625 12.0065 18.3625V18.7625C12.6532 18.7625 13.2 18.2205 13.2 17.556H12.8ZM12.0041 16.7625C12.434 16.7677 12.8 17.1275 12.8 17.556H13.2C13.2 16.9007 12.6499 16.3702 12.0089 16.3625L12.0041 16.7625Z",
    fill: "white",
    mask: "url(#path-4-outside-2_323_15060)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.7e39714a19d327ce3440c7a7fba158c4.svg";
export { ForwardRef as ReactComponent };